import { useEffect, useState, useRef } from "react"
import { useParams, useNavigate } from "react-router-dom"
import css from "../css/blogPostPage.module.css"
import { useQuery } from "@apollo/client"
import { GET_POSTS } from "../../graphql/Post/POST_GQL"

import point1 from "../../images/blogPost/point1.png"
import point2 from "../../images/blogPost/point2.png"
import point3 from "../../images/blogPost/point3.png"
import point4 from "../../images/blogPost/point4.png"
import point5 from "../../images/blogPost/point5.png"
import point6 from "../../images/blogPost/point6.png"
import point7 from "../../images/blogPost/point7.png"
import bluept1 from "../../images/blogPost/bluept1.png"
import bluept2 from "../../images/blogPost/bluept2.png"
import bluept3 from "../../images/blogPost/bluept3.png"

import { Paths } from "../../utils/Paths"

// Function to render Keystone 6 document format
const renderDocument = (document) => {
  if (!document || !Array.isArray(document)) return null

  return document.map((node, index) => {
    switch (node.type) {
      case "heading":
        const HeadingTag = `h${node.level}`
        return (
          <HeadingTag className={"mb-5"} key={index}>
            {node.children.map((child) => child.text).join("")}
          </HeadingTag>
        )
      case "paragraph":
        return (
          <p className="color-para" style={{ fontSize: "18px" }} key={index}>
            {node.children.map((child) => child.text).join("")}
          </p>
        )
      default:
        return (
          <p className="color-para" style={{ fontSize: "18px" }} key={index}>
            {node.children ? node.children.map((child) => child.text).join("") : ""}
          </p>
        )
    }
  })
}

const PostTemp1 = () => {
  // 抑制 ResizeObserver 錯誤警告（僅在開發環境中出現）
  useEffect(() => {
    const handleResizeObserverError = (e) => {
      if (e.message && e.message.includes("ResizeObserver loop completed with undelivered notifications")) {
        e.preventDefault()
        e.stopImmediatePropagation()
        return false
      }
    }

    const handleUnhandledRejection = (e) => {
      if (e.reason && e.reason.message && e.reason.message.includes("ResizeObserver")) {
        e.preventDefault()
        return false
      }
    }

    window.addEventListener("error", handleResizeObserverError)
    window.addEventListener("unhandledrejection", handleUnhandledRejection)

    // 也處理 console 錯誤
    const originalError = console.error
    console.error = (...args) => {
      if (args[0] && typeof args[0] === "string" && args[0].includes("ResizeObserver")) {
        return // 靜默 ResizeObserver 錯誤
      }
      originalError.apply(console, args)
    }

    return () => {
      window.removeEventListener("error", handleResizeObserverError)
      window.removeEventListener("unhandledrejection", handleUnhandledRejection)
      console.error = originalError
    }
  }, [])

  const { loading, error, data } = useQuery(GET_POSTS)
  const { postId } = useParams()
  const [post, setPost] = useState(null)
  const [posts, setPosts] = useState(null)
  const [activeSection, setActiveSection] = useState("")
  const [showStickyToc, setShowStickyToc] = useState(false)
  const navigate = useNavigate()
  const stickyTocRef = useRef(null)

  // 重置 sticky TOC 滾動位置的輔助函數
  const forceResetTocScroll = (targetSectionId = null) => {
    if (!stickyTocRef.current) {
      return
    }

    const tocList = stickyTocRef.current
    let targetScrollLeft = 0

    // 如果是第一個section，確保滾動到最左邊（0位置）
    if (!targetSectionId || targetSectionId === tableOfContents[0]?.id) {
      targetScrollLeft = 0
    }
    // 對於其他section，將活躍按鈕放在視野最左邊（考慮 padding）
    else {
      const targetButton = tocList.querySelector(`a[href="#${targetSectionId}"]`)
      if (targetButton) {
        // 獲取容器的 padding-left 值
        const computedStyle = window.getComputedStyle(tocList)
        const paddingLeft = parseInt(computedStyle.paddingLeft) || 16

        // 將按鈕滾動到視野最左邊，考慮 padding
        targetScrollLeft = Math.max(0, targetButton.offsetLeft - paddingLeft)
      }
    }

    // 統一的滾動設置函數
    const setScroll = () => {
      // 強制設置CSS屬性 - 確保手機兼容
      tocList.style.scrollBehavior = "auto"
      tocList.style.overflowX = "auto"
      tocList.style.webkitOverflowScrolling = "touch" // iOS 支援

      // 多重滾動設置，確保在各種設備上都能工作
      try {
        // 方法1: 直接設置 scrollLeft
        tocList.scrollLeft = targetScrollLeft

        // 方法2: 使用 scrollTo API
        if (tocList.scrollTo) {
          tocList.scrollTo({
            left: targetScrollLeft,
            behavior: "auto",
          })
        }

        // 方法3: 強制DOM重繪（手機瀏覽器有時需要）
        tocList.style.transform = "translateZ(0)" // 觸發硬體加速

        // 方法4: 使用 Element.scroll (舊版瀏覽器相容)
        if (tocList.scroll) {
          tocList.scroll(targetScrollLeft, 0)
        }
      } catch (error) {
        // 靜默處理錯誤
      }
    }

    // 使用多重保險的滾動設置
    setScroll()

    // 對手機設備使用更多的確認機制
    requestAnimationFrame(() => {
      setScroll()

      // 最終檢查
      setTimeout(() => {
        if (Math.abs(tocList.scrollLeft - targetScrollLeft) > 2) {
          try {
            tocList.scrollLeft = targetScrollLeft
            // 強制觸發重繪
            tocList.style.display = "flex"
          } catch (error) {
            // 靜默處理錯誤
          }
        }
      }, 150)
    })
  }

  // 目錄數據
  const tableOfContents = [
    { id: "section1", title: "免TU（信貸報告）貸款是什麼？有什麼好處？" },
    { id: "section2", title: "Moving up免TU貸款特點" },
    { id: "section3", title: "免TU貸款類型（不限於）" },
    { id: "section4", title: "網上免TU貸款「話咁快」到手簡單三步免露面 A.I.極快審批" },
  ]
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" })

    // 監聽滾動事件來高亮當前章節和控制 sticky TOC
    const handleScroll = () => {
      const sections = tableOfContents.map((item) => document.getElementById(item.id))
      const scrollPosition = window.scrollY + 200

      // 檢查是否顯示 sticky TOC
      let tocElement = document.querySelector(`.${css.table_of_contents_mobile}`)
      if (!tocElement) {
        tocElement = document.querySelector(".table_of_contents_mobile")
      }

      if (tocElement) {
        const tocRect = tocElement.getBoundingClientRect()
        // 當原始 TOC 滾出視野時顯示 sticky TOC
        const shouldShowSticky = tocRect.bottom < 0
        setShowStickyToc(shouldShowSticky)
      } else {
        // 如果找不到 mobile TOC，使用滾動位置作為後備
        if (window.scrollY > 500) {
          setShowStickyToc(true)
        }
      }

      let newActiveSection = ""

      // 從上到下檢查每個章節
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i]
        if (section) {
          const sectionTop = section.offsetTop
          const sectionBottom = sectionTop + section.offsetHeight

          // 如果當前滾動位置在這個章節內
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            newActiveSection = tableOfContents[i].id
            break
          }
          // 如果滾動位置在第一個章節之前
          else if (i === 0 && scrollPosition < sectionTop) {
            newActiveSection = tableOfContents[i].id
            break
          }
          // 如果是最後一個章節且滾動位置在它之後
          else if (i === sections.length - 1 && scrollPosition >= sectionTop) {
            newActiveSection = tableOfContents[i].id
            break
          }
        }
      }

      // 只有當章節確實改變時才更新狀態
      if (newActiveSection && newActiveSection !== activeSection) {
        setActiveSection(newActiveSection)
      }
    }

    // 使用 throttle 來減少事件觸發頻率
    let ticking = false
    const throttledHandleScroll = () => {
      if (!ticking) {
        setTimeout(() => {
          handleScroll()
          ticking = false
        }, 16)
        ticking = true
      }
    }

    window.addEventListener("scroll", throttledHandleScroll, { passive: true })
    window.addEventListener("resize", throttledHandleScroll, { passive: true })

    // 初始化第一個章節為活動狀態
    setActiveSection(tableOfContents[0]?.id)

    return () => {
      window.removeEventListener("scroll", throttledHandleScroll)
      window.removeEventListener("resize", throttledHandleScroll)
    }
  }, [])

  // 監聽 activeSection 變化，自動滾動 sticky TOC
  useEffect(() => {
    // 只有當 sticky TOC 顯示且有 activeSection 時才觸發滾動
    if (showStickyToc && activeSection && stickyTocRef.current) {
      // 使用 timeout 確保 DOM 更新完成
      setTimeout(() => {
        forceResetTocScroll(activeSection)
      }, 50)
    }
  }, [activeSection, showStickyToc])

  useEffect(() => {
    if (data) {
      setPosts(data?.posts)
    }
  }, [data])

  useEffect(() => {
    if (posts) {
      const foundPost = posts.find((post) => post.id === postId)
      setPost(foundPost)
    }
  }, [posts, postId])

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" })
      setActiveSection(sectionId)

      const stickyToc = document.querySelector(`.${css.table_of_contents_sticky}.${css.visible}`)
      if (stickyToc && stickyTocRef.current) {
        setTimeout(() => {
          forceResetTocScroll(sectionId)
        }, 100)
      }
    }
  }

  if (loading) return <p>請等待一下...</p>
  if (error) return <p>Error: {error.message}</p>

  return (
    <div className={`${css.blog_post_page} fade-in-element`} style={{ minHeight: "200vh" }}>
      {/* Mobile Sticky TOC Bar */}
      <div
        className={`${css.table_of_contents_sticky} ${showStickyToc ? css.visible : ""}`}
        style={{ display: showStickyToc ? "block" : "none" }} // 強制設置 display
      >
        <ul className={css.toc_list} ref={stickyTocRef}>
          {tableOfContents.map((item, index) => (
            <li key={item.id} className={css.toc_item}>
              <a
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault()
                  scrollToSection(item.id)
                }}
                className={`${css.toc_link} ${activeSection === item.id ? css.active : ""}`}
              >
                {index + 1}. {item.title}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className={`${css.left_side}`}>
        <h1 className="color4 pb-2">{post?.title}</h1>
        <img src={post?.banner?.url} alt={"免TU貸款攻略－Moving up"} className={css.postBanner} />

        {/* Mobile版本：作者資訊和目錄在文章上方 */}
        <div className={css.mobile_meta}>
          <div className={css.author_info_mobile}>
            <p className="color-info">作者：Moving up 專業團隊</p>
            <p className="color-info">更新日期：2025 – 7 – 03</p>
          </div>

          <div className={css.table_of_contents_mobile}>
            <h3 className="color4 mb-3">目錄</h3>
            <ul className={css.toc_list}>
              {tableOfContents.map((item, index) => (
                <li key={item.id} className={css.toc_item}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault()
                      scrollToSection(item.id)
                    }}
                    className={`${css.toc_link} ${activeSection === item.id ? css.active : ""}`}
                  >
                    {index + 1}. {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 文章內容區域 */}
        <div className={css.content_wrapper}>
          {/* 原有內容渲染 */}
          <div>{renderDocument(post?.content?.document)}</div>
          <section id="section1" className={css.content_section}>
            <br />
            <h2>免TU（信貸報告）貸款是什麼？有什麼好處？</h2>
            <p>
              信貸評級（TU評級）好重要，會影響借款人將來的貸款額、利息及還款期，若信貸評級低，利息會較高，甚至被拒絕申請貸款。每次申請傳統貸款，借貸機構都會向環聯TransUnion索取申請人的信用報告，並且留下查詢紀錄，此舉有機會降低申請人的信貸評級，繼而影響他們以後的理財計劃。
            </p>
            <img src={point1} alt="免TU貸款好處" className={css.point_image} />
            <p>
              而Moving
              up的免TU貸款不會查閱申請人的信用報告，保證貸款查詢不影響信貸評級分數，正正適合有意買樓、沒有固定入息證明的生意人、自僱人士、信貸評級不高的人等申請人，讓他們更容易申請買樓上車的按揭貸款、銀行貸款、高額貸款、結餘轉戶或其他分期計劃，以及獲得更優惠利率，減低貸款負擔。
            </p>
            <img src={point2} alt="免TU貸款好處" className={css.point_image} />
            <p>此外，免除了TU查詢、等待回覆等程序，免TU貸款審批速度比傳統銀行申請流程快得多。</p>
            <div className={css.apply_button_container}>
              <button className="apply_btn mt-5 button_hover_motion2" onClick={() => (window.location.href = Paths.userLogin)}>
                立即申請
              </button>
            </div>
          </section>

          <section id="section2" className={css.content_section}>
            <h2>Moving up免TU貸款特點</h2>
            <h3>
              <u>獨創A.I.智能系統極速審批：</u>
            </h3>
            <p>
              <b>最快12秒</b> 快速批核
            </p>
            <h3>
              <u>快速過數：</u>
            </h3>
            <p>
              <b>15分鐘現金到手</b>，提升信貸評級
            </p>
            <img src={point3} alt="免TU貸款特點" className={css.point_image} />
            <h3>
              <u>免TU貸款金額高：</u>
            </h3>
            <p>
              <b>可達3,000,000</b>，按貸款計劃而定
            </p>
            <img src={point4} alt="免TU貸款特點" className={css.point_image} />
            <h3>
              <u>全程網上辦妥：</u>
            </h3>
            <p>免TU貸款無須露面，一鍵完成申請</p>
            <img src={point5} alt="免TU貸款特點" className={css.point_image} />
            <h3>
              <u>7x24全天候在線解答：</u>
            </h3>
            <p>為客戶線上解答任何免TU借貸相關疑問，急客戶所急，唔使再左等右等</p>
            <img src={point6} alt="免TU貸款特點" className={css.point_image} />
            <h3>
              <u>特設靈活還款期</u>
            </h3>
            <h3>
              <u>高度重視客戶私隱</u>
            </h3>
            <h3>
              <u>
                特設靈活還款期為有需要人士申請免TU的<b>免繁複文件證明貸款</b>
              </u>
            </h3>
            <img src={point7} alt="免TU貸款特點" className={css.point_image} />
            <br />
            <div className={css.apply_button_container}>
              <button className="apply_btn mt-5 button_hover_motion2" onClick={() => (window.location.href = Paths.userLogin)}>
                立即申請
              </button>
            </div>
          </section>

          <section id="section3" className={css.content_section}>
            <h2>免TU貸款類型（不限於）：</h2>
            <p>我們提供多種免TU貸款類型：</p>

            <ul>
              <li>
                <a href={Paths.personalLoan}>私人貸款</a>
              </li>
              <li>中小企貸款</li>
              <li>
                <a href={Paths.propertyLoan}>業主特惠貸款</a>
              </li>
              <li>租客特惠貸款</li>
              <li>稅務貸款</li>
            </ul>
          </section>

          <section id="section4" className={css.content_section}>
            <div className={css.section4_header}>
              <h2>
                網上免TU貸款 「話咁快」到手
                <br />
                簡單三步免露面 A.I.極快審批
              </h2>
            </div>
            <h3>
              <img src={bluept1} alt="" className={css.bluept} />
              <b>2分鐘</b> 完成申請：
            </h3>
            <p>網上填寫身份證、手提電話等資料，免TU貸款全程網上辦妥，無須露面。</p>
            <h3>
              <img src={bluept2} alt="" className={css.bluept} />
              <b>12秒</b> A.I.閃批：
            </h3>
            <p>A.I.智能系統極速審批及即時制訂專屬免TU貸款計劃，進行網上簽約即可確認貸款。</p>
            <h3>
              <img src={bluept3} alt="" className={css.bluept} />
              <b>15分鐘</b> 大額現金到手：
            </h3>
            <p>極速過數去客人銀行戶口，即申請即有Cash！</p>
            <div className={css.apply_button_container}>
              <button className="apply_btn mt-5 button_hover_motion2" onClick={() => (window.location.href = Paths.userLogin)}>
                立即申請
              </button>
            </div>
          </section>
        </div>
      </div>

      <div className={css.right_side}>
        {/* Desktop版本：作者資訊和目錄在右側 */}
        <div className={css.desktop_meta}>
          <div className={css.author_info}>
            <p className="color-info">作者：Moving up 專業團隊</p>
            <p className="color-info">更新日期：2025 – 7 – 03</p>
          </div>

          <div className={css.table_of_contents}>
            <h3 className="color4 mb-3">目錄</h3>
            <ul className={css.toc_list}>
              {tableOfContents.map((item, index) => (
                <li key={item.id} className={css.toc_item}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault()
                      scrollToSection(item.id)
                    }}
                    className={`${css.toc_link} ${activeSection === item.id ? css.active : ""}`}
                  >
                    {index + 1}. {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PostTemp1
